import './Methodology.css';
import content from '../data/content.json';

const Methodology: React.FC = () => {
  return (
    <section className="methodology" id="crencas">
      <div className="container">
        <h2>{content.beliefs.title}</h2>
        <p className="methodology-headline">{content.beliefs.headline}</p>

        <div className="methodology-content">
          {content.beliefs.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
          <p className="methodology-cta">
            <strong>{content.beliefs.cta}</strong>
          </p>
          <div className="methodology-cta-button">
            <a href="https://linktr.ee/arp3studio" target="_blank" rel="noopener noreferrer" className="cta-button">
              Entre em Contato
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
